import apiClient from "./client";
import type {
  LoginRequest,
  AuthResponse,
  User,
  RegisterRequest,
  SendCodeRequest,
} from "@/types";

const BASE = "/auth";

export async function login(req: LoginRequest): Promise<AuthResponse> {
  const { data } = await apiClient.post(`${BASE}/login`, req);
  return data.data;
}

export async function sendCode(req: SendCodeRequest): Promise<void> {
  await apiClient.post(`${BASE}/send-code`, req);
}

export async function register(req: RegisterRequest): Promise<User> {
  const { data } = await apiClient.post(`${BASE}/register`, req);
  return data.data;
}

export async function getMe(): Promise<User> {
  const { data } = await apiClient.get(`${BASE}/me`);
  return data.data;
}
